import angular from 'angular';
import FuelTableController from './fuel-table.controller';

import './fuel-table.styles.scss';

export default angular.module('autoboard.fuelTable', [])
  .controller('FuelTableController', FuelTableController)
  .name;
